// Polyfills
// import 'whatwg-fetch' // fetch API: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
// import 'intersection-observer' // Intersection Observer API: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
import 'classlist-polyfill'
import smoothscroll from 'smoothscroll-polyfill'

// Global tooling
import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit.js' // Parent-fit-plugin for lazysizes, make data-sizes="auto" work well with object-fit
import 'lazysizes/plugins/object-fit/ls.object-fit'
// import 'simplebar' // or "import SimpleBar from 'simplebar';" if you want to use it manually.

import initVideoPlayers from './init-video-players'
import initMobileMenuController from './init-mobile-menu-controller'
import initPageScrolledController from './init-page-scrolled-controller'
import initStoryController from './init-story-controller'
import initHeroSliderController from './init-hero-slider-controller'
// import initFiltersModalController from './init-filters-modal-controller'
import initAboutController from './init-about-controller'
import initPhotoSwipe from './init-photoswipe'
import LogoInterferenceController from './controllers/logo-interference-controller'
import initBackToTopController from './init-back-to-top-controller'
import initSmoothAnchorScroll from './init-smooth-anchor-scroll'
import initNewsletterBarController from './init-newsletter-bar-controller'
import initNewsletter from './init-newsletter'
import initCookieConsent from './init-cookie-consent'
import initSubnavBar from './init-subnav-bar'
import initPopupControllers from './init-popup-controllers'

smoothscroll.polyfill()

window.APP_GLOBALS = new LogoInterferenceController()

// initVimeoVideos()
initVideoPlayers()
initMobileMenuController()
initPageScrolledController()
initStoryController()
initHeroSliderController()
// initFiltersModalController()
initPhotoSwipe()
initAboutController()
initNewsletterBarController()
initBackToTopController()
initSmoothAnchorScroll()
initNewsletter()
initCookieConsent()
initPopupControllers()
initSubnavBar()
